import FieldContainer from '../../../../shared/FormElements/FieldContainer/FieldContainer';
import RcSelect from '../../../../shared/FormElements/Selects/RcSelect';

const archOptions = [
  { id: 'upper', name: 'Top retainer' },
  { id: 'lower', name: 'Bottom retainer' },
  { id: 'both', name: 'Both retainers' },
];

function WarrantyFormArchSelection() {
  return (
    <FieldContainer name="arch" label="Which retainer?" required={true}>
      <RcSelect name="arch" data={archOptions} clearable={false} />
    </FieldContainer>
  );
}

export default WarrantyFormArchSelection;
